import { CATEGORY_PARAMS } from '@common/constants/product-list';
import type { PageProps } from '@common/pages/product-list/components/product-list-page';
import ProductListPage from '@common/pages/product-list/components/product-list-page';
import { ProductListContextProvider } from '@common/pages/product-list/context/product-list';
import type { GetServerSidePropsContext } from 'next/types';
/* istanbul ignore next */
export const getServerSideProps = async (ctx: GetServerSidePropsContext) => {
  const pageType =
    ctx.query.type === CATEGORY_PARAMS.VIRTUAL_CATEGORY ? 'virtualCategory' : 'displayCategory';
  return ProductListPage.getServerSideProps(ctx, pageType);
};

const CategoryPage = (props: PageProps) => {
  return (
    <ProductListContextProvider renderType="ahaa" recoilState={props.recoilState}>
      <ProductListPage {...props} />
    </ProductListContextProvider>
  );
};
export default CategoryPage;
